"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FraxGaugeFXSRewardsDistributor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_timelock_address",
                type: "address",
            },
            {
                internalType: "address",
                name: "_curator_address",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reward_token_address",
                type: "address",
            },
            {
                internalType: "address",
                name: "_gauge_controller_address",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "distibutions_state",
                type: "bool",
            },
        ],
        name: "DistributionsToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "gauge_address",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "is_middleman",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "is_active",
                type: "bool",
            },
        ],
        name: "GaugeStateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "RecoveredERC20",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "gauge_address",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reward_amount",
                type: "uint256",
            },
        ],
        name: "RewardDistributed",
        type: "event",
    },
    {
        inputs: [],
        name: "curator_address",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "gauge_address",
                type: "address",
            },
        ],
        name: "currentReward",
        outputs: [
            {
                internalType: "uint256",
                name: "reward_amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "gauge_address",
                type: "address",
            },
        ],
        name: "distributeReward",
        outputs: [
            {
                internalType: "uint256",
                name: "weeks_elapsed",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reward_tally",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "distributionsOn",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gauge_controller",
        outputs: [
            {
                internalType: "contract IFraxGaugeController",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "gauge_whitelist",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "is_middleman",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "last_time_gauge_paid",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "recoverERC20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reward_token_address",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_new_curator_address",
                type: "address",
            },
        ],
        name: "setCurator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_gauge_controller_address",
                type: "address",
            },
        ],
        name: "setGaugeController",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_gauge_address",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_is_middleman",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "_is_active",
                type: "bool",
            },
        ],
        name: "setGaugeState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_new_timelock",
                type: "address",
            },
        ],
        name: "setTimelock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock_address",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDistributions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class FraxGaugeFXSRewardsDistributor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_timelock_address, _curator_address, _reward_token_address, _gauge_controller_address, overrides) {
        return super.getDeployTransaction(_timelock_address, _curator_address, _reward_token_address, _gauge_controller_address, overrides || {});
    }
    deploy(_timelock_address, _curator_address, _reward_token_address, _gauge_controller_address, overrides) {
        return super.deploy(_timelock_address, _curator_address, _reward_token_address, _gauge_controller_address, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.FraxGaugeFXSRewardsDistributor__factory = FraxGaugeFXSRewardsDistributor__factory;
FraxGaugeFXSRewardsDistributor__factory.bytecode = _bytecode;
FraxGaugeFXSRewardsDistributor__factory.abi = _abi;
//# sourceMappingURL=FraxGaugeFXSRewardsDistributor__factory.js.map